/*
 * © 2025 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */

import { ProcessActionDetails } from "@centralwebteam/narwhal";
import { AlertLevel } from "@centralwebteam/jellyfish";
import constants from "@/constants";

export function getProcessUpdateAlertLevel(
  subType: string,
  details: ProcessActionDetails | undefined
): AlertLevel {
  if (subType === "OffsetChangeDetected") {
    return AlertLevel.offsetOtherInfo;
  }
  if (subType === "OffsetAdjustmentCalculation") {
    return details?.executionSettings?.updateMode === "Control"
      ? AlertLevel.offsetInfo
      : AlertLevel.offsetOtherInfo;
  }
  if (subType === "MachineAdjustmentApplied") {
    return AlertLevel.offsetOther;
  }
  if (subType === "MachineAdjustmentCalculation") {
    return AlertLevel.offsetOtherInfo;
  }
  if (
    subType === "OffsetAdjustmentApplied" &&
    details?.executionSettings?.updateMode === "Control"
  ) {
    if (
      details?.offsetLifeCycle &&
      details.offsetLifeCycle?.wearPercentage > constants.offsetErrorMin
    ) {
      return AlertLevel.offsetError;
    } else if (
      details?.offsetLifeCycle &&
      details.offsetLifeCycle?.wearPercentage >= constants.offsetWarningMin &&
      details.offsetLifeCycle?.wearPercentage <= constants.offsetWarningMax
    ) {
      return AlertLevel.offsetWarning;
    } else {
      return AlertLevel.offset;
    }
  }
  if (details?.executionSettings?.updateMode) {
    return details.executionSettings.updateMode === "Control"
      ? AlertLevel.offset
      : AlertLevel.offsetOther;
  }

  return AlertLevel.offset;
}
